import {GetterTree} from "vuex";
import {UserRolesState} from "@/store/user_management/roles/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<UserRolesState, RootState> = {
  userRoles: state => state.userRoles ?? []
}